import React, { useEffect, useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { FaUserDoctor } from "react-icons/fa6";
import { GoArrowLeft } from "react-icons/go";
import DoctorAddBasicInfo from "../../Large-forms/DoctorAddBasicInfo";
import DoctorProfessionalInfo from "../../Large-forms/DoctorProfessionalInfo";
import DoctorAddEduInfo from "../../Large-forms/DoctorAddEduInfo";
import AddStaffBasic from "./AddStaffBasic";
import StaffProffessionalInfo from "./StaffProffessionalInfo";
import EmployementDetails from "./EmployementDetails";
import AccessandRoles from "./AccessandRoles";

function StaffStepper() {
  const [currentStep, setCurrentStep] = useState(1);
  const [doctorData, setDoctorData] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const isEditMode = Boolean(location.state?.doctorId);

  useEffect(() => {
    if (isEditMode) {
      // Static dummy data for edit mode
      const staticData = {
        basicinfo: {
          useruniqueid: "U12345",
          doctorId: 101,
          fullname: "Dr. John Smith",
          gender: "Male",
          dateofbirth: "1980-04-15",
          phonenumber: "+911234567890",
          emailaddress: "john.smith@clinic.com",
          office_clinicaddress: "123 Main St, Springfield",
          languages_Known: "English, Spanish",
          reffered_By: "Dr. Jane Doe",
          imageURL: null,
        },
        professionalinfo: {
          doctorid: 101,
          specialization: "Cardiology,Internal Medicine",
          experience: "12",
          medicallicensenumber: "MLN123456",
          professionalaffiliations: "American Medical Association",
        },
        eductioncertificates: [
          {
            educationcertificationid: 1,
            doctorid: 101,
            useruniqueid: "U12345",
            userclinicid: "C001",
            qualification: "MBBS",
            university: "ABC Medical University",
            fieldofStudy: "General Medicine",
            certifications: "Diploma in Cardiology",
            percentages: "85",
            startdate: "2000-06-01",
            lastdate: "2005-05-30",
          },
        ],
      };
      setDoctorData(staticData);
    } else {
      setDoctorData(null);
    }
  }, [isEditMode]);

  // Local form state for basic info etc.
  const [formValues, setFormValues] = useState({
    fullname: "",
    gender: "",
    dateofbirth: "",
    phonenumber: "",
    email: "",
    address: "",
    languagesknown: [],
    refferedby: "",
    ProfilePicture: null,
    specialization: [],
    yearsofexperience: "",
    medicallicensenumber: "",
    professionalaffiliations: "",
    Eductioncertificates: [],
  });
  const fakeFormik = {
  values: formValues,
  setFieldValue: (field, value) => {
    setFormValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  },
  handleChange: (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  },
  handleBlur: () => {},
  touched: {},
  errors: {},
};

const steps = [
  {
    content: (
      <>
        <AddStaffBasic formik={fakeFormik} isEditMode={isEditMode} />
        <StaffProffessionalInfo formik={fakeFormik} isEditMode={isEditMode} />
        <DoctorAddEduInfo
        eduVars={{
          draftEducation: {
            doctorid: doctorData?.doctorid ?? 0,
            highestQualification: "",
            university: "",
            fieldofstudy: "",
            certifications: "",
            percentage: "",
            startDate: "",
            endDate: "",
          },
          setDraftEducation: () => {},
          editEducationIndex: null,
          setEditEducationIndex: () => {},
          formik: fakeFormik,
          doctorData,
          handleRemoval: () => {},
        }}
      />
      </>
    ),
  },
  {
    content: (
      <>
      <EmployementDetails formik={fakeFormik} isEditMode={isEditMode} />
      <AccessandRoles formik={fakeFormik} isEditMode={isEditMode} />
        </>
    ),
  },
];


  const progressWidth = (currentStep / steps.length) * 100;

  const handleMoveBack = () => {
    navigate(-1);
  };

  const handleNextStep = () => {
    setCurrentStep((prev) => Math.min(prev + 1, steps.length));
  };

  const handleBackStep = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };

  // Stub for submit - no API, no alerts
  const handleSubmit = (e) => {
    e.preventDefault();
    // Here, just simulate successful submit and navigate back
    navigate("/doctors");
  };

  return (
    <>
      <style>{`
       
      `}</style>

      <div className="mb-3 flex items-center gap-2">
        <button
          className="bg-white inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium border border-gray-300 hover:bg-gray-100 p-2"
          onClick={handleMoveBack}
          type="button"
        >
          <GoArrowLeft />
          <span className="sr-only">Back</span>
        </button>
        <h2 className="text-xl font-semibold text-gray-800">
          {isEditMode ? "Edit Staff" : "Add Staff"}
        </h2>
      </div>

      <div className="card p-4 rounded-lg shadow-md border border-gray-200">
        <div className="w-full bg-gray-300 rounded-full h-1.5 mb-5">
          <div
            className="bg-gray-500 h-1.5 rounded-full transition-width ease-in-out duration-300"
            style={{ width: `${progressWidth}%`, backgroundColor: "#A2AD91" }}
          ></div>
        </div>

        <form onSubmit={handleSubmit}>
          {steps[currentStep - 1].content}

          <div
            className={`flex mt-6 ${
              currentStep === 1 ? "justify-end" : "justify-between"
            }`}
          >
            {currentStep !== 1 && (
              <button
                className="gradient-dark-button px-4"
                onClick={handleBackStep}
                type="button"
              >
                Back
              </button>
            )}

            {currentStep < steps.length && (
              <button
                className="gradient-button px-4"
                onClick={handleNextStep}
                type="button"
              >
                Next
              </button>
            )}

            {currentStep === steps.length && (
              <button className="gradient-button px-4" type="submit">
                Finish
              </button>
            )}
          </div>
        </form>
      </div>
    </>
  );
}

export default StaffStepper;
